import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import SUPPORTED_ICONS from './SUPPORTED_ICONS';

/**
 *
 */
const SocialIcon = ({ icon, currentColor, brandColorOnHover, title }) => {
  const className = cn(
    'c-social-icon',
    `c-social-icon--${icon}`,
    { 'c-social-icon--current-color': currentColor },
    { 'c-social-icon--brand-color-on-hover': brandColorOnHover }
  );
  return (
    <svg className={className}>
      <title>{title}</title>
      <use xlinkHref={`#c-social-icon-symbol-${icon}`} />
    </svg>
  );
};

export default SocialIcon;

SocialIcon.propTypes = {
  icon: PropTypes.oneOf(SUPPORTED_ICONS).isRequired,
  currentColor: PropTypes.bool,
  brandColorOnHover: PropTypes.bool,
  title: PropTypes.string,
};

SocialIcon.defaultProps = {
  currentColor: false,
  brandColorOnHover: false,
  title: '',
};
